import { Source118 } from './Source118';

/**
 * enter_code_screen_shown
 * При переходе с экрана авторизации по 
звонку на экран ввода кода из смс требуется 
указать новый сорус в событии
 */
export interface EnterCodeScreenShown {
  source: Source118;
}

export function mapEnterCodeScreenShownEvent(event: EnterCodeScreenShown): object {
  const props: Record<string, unknown> = {
      source: event.source,
  };

  return {
    event: 'analytics_event',
    event_name: 'enter_code_screen_shown',
    event_properties: Object.fromEntries(
      Object.entries(props)
        .filter(([_, v]) => v != null)
        .map(([k, v]) => [k, String(v)])
    ),
  };
}
